import { apiClient } from '../_helpers';
import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';

export const settingsService = {
  getSettings,
  updateSettings
};

async function getSettings(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/clients/${clientId}/settings`, requestOptions).then(handleResponse);
}

/*
async function getSettings(clientId) {
  try {
    alert('in service - ' + clientId)
    const response = await apiClient(`clients/${clientId}/settings`)
      .get();

      alert(response.data);
    return response.data;
  } catch (error) {
    return error;
  }
}
*/

async function updateSettings(params) {
  try {
    const response = await apiClient(`clients/${params.clientId}/settings`)
      .put('', `${JSON.stringify(params)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}